import { createAction } from "@reduxjs/toolkit";
import Theme from "./types/Theme";

export const previewTheme =
  createAction<Record<string, string>>("PREVIEW_THEME");

export const themeChanged = createAction<Theme>("THEME_CHANGED");
export const restoreTheme = createAction("RESTORE_THEME");
